function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import isPropValid from "@emotion/is-prop-valid";
import { styled } from "@mui/material";
import { Text } from "./Text";
var StyledModalHeader = styled('div', {
    shouldForwardProp: isPropValid
})(function(props) {
    return _define_property({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: props.theme.spacing(6, 10)
    }, props.theme.breakpoints.down('sm'), {
        padding: props.theme.spacing(6)
    });
});
var StyledModalHeaderText = styled(Text)(function(props) {
    return _define_property({
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: 0,
        width: '100%'
    }, props.theme.breakpoints.down('sm'), {
        justifyContent: 'center'
    });
});
export var ModalHeader = function(_param) {
    var id = _param.id, props = _object_without_properties(_param, [
        "id"
    ]);
    return /*#__PURE__*/ _jsx(StyledModalHeader, _object_spread_props(_object_spread({
        "data-component": "modalHeader"
    }, props), {
        children: /*#__PURE__*/ _jsx(StyledModalHeaderText, {
            color: "grey100",
            id: id,
            variant: "e2",
            children: props.children
        })
    }));
};
ModalHeader.displayName = 'ModalHeader';

//# sourceMappingURL=ModalHeader.js.map